<!-- Upload Area for Drag and Drop -->
<div
    class="dorpdownarea w100 col gap-24 align-items-center"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="file.click()"
    *ngIf="fileList.length == 0"
>
    <div class="w100 col gap-16 align-items-center">
        <rr-icon name="upload"></rr-icon>
        <div class="col w100 gap-4 align-items-center">
            <span i18n class="strong">Drag and drop files here</span>
            <span i18n class="tiny"
                >Supported formats: .pdf .txt .md .csv .json (Max. file size is
                {{ maxFileSizeInBite / 1000000 }}MB)</span
            >
        </div>
    </div>
    <rr-btn size="Small" type="Secondary">Browse files</rr-btn>
</div>
<div class="errorlist col gap-4-w100" *ngIf="errorList && errorList.length > 0">
    <div class="row gap-8 align-center" *ngFor="let e of errorList">
        <rr-icon name="error" tone="error"></rr-icon>
        <div class="color-error tiny w100">
            @if (e === "ERROR") {
                failed
            }
            @if (e === "ERROR_TO_BIG") {
                File upload failed: size is too big
            }
            @if (e === "ERROR_TOO_MUCH_TEXT") {
                File upload failed: document has too much text. Limit is
                {{ maxCharsForTextExtraction }} characters
            }
            @if (e === "ERROR_WRONG_TYPE") {
                File upload failed: unsupported file type
            }
        </div>
    </div>
</div>
<!-- END Upload Area for Drag and Drop -->

<div class="col w100 gap-8" *ngIf="fileList.length > 0 && !extractedObject">
    <div
        class="row space-between w100 align-center filerow"
        *ngFor="let file of fileList"
    >
        <div class="row align-center gap-16 file-name-section">
            <rr-icon name="file" tone="nutral" class="roundicon"></rr-icon>
            <div class="col file-text">
                <span class="color-strong tiny file-name-text">{{
                    file.name
                }}</span>
                <span class="tiny">{{ file.size | calcFileSizeInKb }}</span>
            </div>
        </div>

        <div class="row gap-16 align-center">
            <span class="tiny" *ngIf="file.extractingState === 'PENDING'"
                ><rr-spinner></rr-spinner> Extracting...</span
            >
            <span
                class="tiny success"
                *ngIf="file.extractingState === 'SUCCESS'"
                >successful</span
            >

            <rr-icon
                [name]="
                    file.extractingState === 'ERROR'
                        ? 'reload'
                        : file.extractingState === 'ERROR_TO_BIG'
                          ? 'reload'
                          : 'trash'
                "
                tone="nutral"
                class="pointer"
                (click)="deleteFile(file)"
            ></rr-icon>
        </div>
    </div>
</div>

<!-- Disclaimer INFO  -->
<rr-disclaimer
    [type]="disclaimerTypes.DATA"
    *ngIf="!extractedObject"
></rr-disclaimer>

<div class="col w100 gap-8" *ngIf="fileList.length > 0 && extractedObject">
    <!-- <div class="row align-center gap-24" *ngFor="let file of fileList">
      <div class="row gap-8 align-center">
        <rr-icon name="file" color="nutral" size="Small"></rr-icon>
        <span (click)="openFileNewTab(file)" class="tiny link">{{
          file.name
        }}</span>
      </div>
      <rr-icon
        name="close"
        class="pointer"
        color="nutral"
        (click)="deleteFile(file)"
        size="Small"
      ></rr-icon>
    </div> -->
</div>
<div class="summaryresult col gap-16 w100" *ngIf="extractedObject">
    <div class="row gap-24 space-between w100">
        <div class="col gap-4">
            <!-- <span class="strong">{{ extractedObject.document_title }}</span> -->
        </div>
        @if (editResponse === false) {
            <div class="row gap-8">
                <rr-btn
                    size="Small"
                    type="Secondary"
                    iconStart="edit"
                    (click)="openEditMode()"
                    >Edit</rr-btn
                >
            </div>
        } @else {
            <div class="row gap-8">
                <rr-btn
                    size="Small"
                    type="Secondary"
                    iconStart="check"
                    (click)="saveEditing()"
                    >Save</rr-btn
                >
                <rr-btn
                    size="Small"
                    type="Secondary"
                    iconStart="close"
                    (click)="cancelEditing()"
                    >Cancel</rr-btn
                >
            </div>
        }
    </div>
    <div class="divider"></div>
    @if (editResponse === false) {
        <div class="strong"></div>
        <div markdown ngPreserveWhitespaces>{{ extractedObject }}</div>
    } @else {
        <rr-textarea
            [FormControl]="control"
            [class.edited]="control.dirty"
            [attr.placeholder]="'Edit value'"
            [fitText]="true"
            class="w100"
        />
    }
</div>

<div class="btnrow row w100 gap-16 space-between align-center">
    <div class="row gap-8">
        <!-- <rr-btn
            size="Small"
            type="Link"
            (click)="uploadNewDocument()"
            *ngIf="extractedObject"
            >Upload new document</rr-btn
        > -->
    </div>
    <div class="row gap-8">
        <rr-btn
            size="Small"
            type="Secondary"
            (click)="close.emit()"
            [disabled]="editResponse"
            >Cancel</rr-btn
        >
        <rr-btn
            size="Small"
            type="Primary"
            [disabled]="
                errorInFiles === true || fileList.length == 0
                    ? true
                    : fileList[0].extractingState === 'PENDING'
                      ? true
                      : false
            "
            (click)="
                (
                    errorInFiles === true || fileList.length == 0
                        ? true
                        : fileList[0].extractingState === 'PENDING'
                          ? true
                          : false
                )
                    ? null
                    : extractedObject
                      ? usecontent.emit(extractedObject)
                      : summerizeDocs()
            "
            >{{ extractedObject ? "Use content" : "Analyze content" }}</rr-btn
        >
    </div>
</div>
<rr-spinner *ngIf="loading"></rr-spinner>
<input
    type="file"
    name="file"
    id="file"
    #file
    hidden
    accept=".pdf, .txt, .rtf, .md, .csv, .json"
    (change)="onFileSelected($event)"
/>
